<div mat-dialog-title>
  <h4>{{ 'properties.list.exportFile' | translate }}
    <!-- <span [ngClass]="{ 'd-none': !model.subject }"> - {{ model.subject }}</span> -->
  </h4>
  <div class="text-muted dialog-subtitle">
  </div>
</div>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="form-wrapper mt-3">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
      <div class="row mb-1">
        <div class="col-12 text-left">
          <button mat-button (click)="onClose()" mat-raised-button mat-default
            class="ml-3">{{ 'common.cta.close' | translate }}</button>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->